var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "overflow-x-auto rounded-lg" }, [
    _c(
      "div",
      {
        staticClass:
          "max-w-screen max-h-screen flex items-center font-sans overflow-hidden",
      },
      [
        _c("div", { staticClass: "w-full" }, [
          _c("div", { staticClass: "bg-white border-t-1 border-gray-300" }, [
            _c(
              "div",
              {
                staticClass:
                  "grid grid-cols-1 xl:grid-cols-4 xxl:grid-cols-6 gap-1 auto-rows-max w-full pt-2",
              },
              [
                _c("div", { staticClass: "col-span-12" }, [
                  _c("p", { staticClass: "text-sm custom-color font-bold" }, [
                    _vm._v(" Projects in Progress "),
                  ]),
                  _c(
                    "div",
                    { staticClass: "overflow-x-auto" },
                    [
                      _c(
                        "div",
                        { staticClass: "min-w-screen flex font-sans rounded" },
                        [
                          _c("div", { staticClass: "w-full" }, [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "rounded mt-6 h-60 overflow-y-auto scrollbar",
                              },
                              [
                                _c(
                                  "table",
                                  {
                                    staticClass: "min-w-max w-full table-auto",
                                  },
                                  [
                                    _vm._m(0),
                                    _c(
                                      "tbody",
                                      {
                                        staticClass:
                                          "text-gray-800 text-sm font-weight-600 bg-white",
                                      },
                                      _vm._l(
                                        _vm.myProjects,
                                        function (project) {
                                          return _c("ProjectRowCard", {
                                            key: project.id,
                                            attrs: {
                                              project: project,
                                              companyId: _vm.companyId,
                                              currentUser: _vm.currentUser,
                                            },
                                            on: {
                                              viewProjects: function ($event) {
                                                return _vm.viewProjects($event)
                                              },
                                              editProjects: function ($event) {
                                                return _vm.editProjects($event)
                                              },
                                            },
                                          })
                                        }
                                      ),
                                      1
                                    ),
                                  ]
                                ),
                              ]
                            ),
                          ]),
                        ]
                      ),
                      _vm.modalShown
                        ? _c("ProjectModal", {
                            attrs: {
                              data: _vm.selectedProject,
                              companyId: _vm.companyId,
                              currentUser: _vm.currentUser,
                            },
                            on: {
                              close: _vm.hideModal,
                              projectUpdated: function ($event) {
                                return _vm.$emit("projectUpdated")
                              },
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                ]),
              ]
            ),
          ]),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("thead", { staticClass: "sticky top-0 z-10" }, [
      _c(
        "tr",
        { staticClass: "bg-blue-100 text-gray-600 text-xs leading-normal" },
        [
          _c("th", { staticClass: "py-1 pl-4 text-left" }, [_vm._v("Project")]),
          _c("th", { staticClass: "py-1 pl-0 text-left" }, [_vm._v("Budget")]),
          _c("th", { staticClass: "py-1 pl-0 text-left" }, [
            _vm._v("Duration"),
          ]),
          _c("th", { staticClass: "py-1 pl-0 text-left" }, [
            _vm._v("Contractors"),
          ]),
          _c("th", { staticClass: "py-1 pl-0 text-left" }, [_vm._v("Tasks")]),
          _c("th", { staticClass: "py-1 pl-0 text-left" }, [_vm._v("Actions")]),
        ]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }